// Utility to parse from Local Storage
export function getLocalStorageItem(name: string): any | null {
  try {
    const item = localStorage.getItem(name);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error parsing Local Storage item: ${name}`, error);
    return null;
  }
}

// Check if consent is given (any `showBanner = false` should hide overlay)
export function isConsentGiven(): boolean {
  const consentData = getLocalStorageItem("TERMLY_API_CACHE");

  if (consentData) {
    // Iterate over all keys in the object
    for (const key in consentData) {
      const section = consentData[key]?.value;
      if (section) {
        // Check all child properties for `showBanner = false`
        for (const subKey in section) {
          if (section[subKey]?.showBanner === false) {
            return true; // Consent is considered given
          }
        }
      }
    }
  }
  return false; // Default: Consent not given
}

// Create and show overlay
export function createOverlay(): HTMLElement {
  const overlay = document.createElement("div");
  overlay.id = "cookie-blocker-overlay";
  overlay.style.position = "fixed";
  overlay.style.top = "0";
  overlay.style.left = "0";
  overlay.style.width = "100%";
  overlay.style.height = "100%";
  overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  overlay.style.zIndex = "9999";
  overlay.style.display = "flex";
  overlay.style.alignItems = "center";
  overlay.style.justifyContent = "center";
  overlay.style.color = "#fff";
  overlay.style.fontSize = "18px";
  overlay.innerHTML =
    "<p>Please provide cookie consent to continue browsing.</p>";
  document.body.appendChild(overlay);
  return overlay;
}
